// extracted by mini-css-extract-plugin
export default {"form":"styles_form__p9BPg","input":"styles_input__H+97J"};